<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">
            {{
              added
                ? 'Create New Channel Viewing Slot'
                : 'Edit Channel Viewing Slot'
            }}
          </h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-8 is-offset-2">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes, errors }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-multiline">
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Name"
                            rules="required"
                          >
                            <b-field
                              label="Name"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.name" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="control">
                          <BaseTimePicker
                            label="Start Time"
                            :increment-minutes="15"
                            v-model="item.start_time"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="control">
                          <BaseTimePicker
                            label="End Time"
                            :increment-minutes="15"
                            v-model="item.end_time"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-12">
                        <div class="control">
                          <b-field label="Days">
                            <div class="block">
                              <b-checkbox
                                v-model="item.days"
                                v-for="day in days"
                                :key="day.value"
                                :native-value="day.value"
                              >
                                {{ day.day }}
                              </b-checkbox>
                            </div>
                          </b-field>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name: 'ManageChannelViewingSlots',
                            params: {
                              id: !added ? item.channel_id : $route.params.id,
                            },
                          }"
                        >
                          Back to List</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          {{ added ? 'Create' : 'Update' }}
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import BaseTimePicker from '@/components/BaseTimePicker'
import ChannelViewingSlotApi from '@/api/channelViewingSlots'

export default {
  name: 'EditChannelViewingSlot',
  components: {
    CardComponent,
    BaseTimePicker,
  },
  metaInfo: {
    title: 'Edit Channel Viewing Slot',
  },
  computed: {
    ...mapGetters(['user']),
  },
  async mounted() {
    this.added = this.$route.name === 'CreateChannelViewingSlot' ? true : false
    if (!this.added) {
      await this.setData()
    }
    this.initialized = true
  },
  data() {
    return {
      loading: false,
      initialized: false,
      added: false,
      item: {
        days: [],
      },
      days: [
        { value: 1, day: 'Monday' },
        { value: 2, day: 'Tuesday' },
        { value: 3, day: 'Wednesday' },
        { value: 4, day: 'Thursday' },
        { value: 5, day: 'Friday' },
        { value: 6, day: 'Saturday' },
        { value: 7, day: 'Sunday' },
      ],
    }
  },
  methods: {
    ...mapActions(['getUser']),
    async setData(id) {
      this.initialized = false
      this.added = false
      this.item = await ChannelViewingSlotApi.getById(
        id || this.$route.params.id
      )
      if (this.item) {
        this.item.start_time = new Date(this.item.start_time)
        this.item.end_time = new Date(this.item.end_time)
        this.item.days = this.item.days.split(',')
      }
      this.initialized = true
    },
    async submit() {
      this.loading = true
      if (!this.item.id) {
        try {
          this.item.channel_id = this.$route.params.id
          let response = await ChannelViewingSlotApi.create(this.item)
          this.$buefy.toast.open({
            message: 'Channel Viewing Slot created successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.$router.push({
            name: 'EditChannelViewingSlot',
            params: { id: response.id },
          })
          await this.setData(response.id)
          this.loading = false
        } catch (err) {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error saving channel viewing slot',
            position: 'is-top',
            type: 'is-danger',
          })
          this.loading = false
        }
      } else {
        try {
          await ChannelViewingSlotApi.update(this.item)
          this.$buefy.toast.open({
            message: 'Channel Viewing Slot updated successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          await this.setData()
          this.loading = false
        } catch (err) {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error saving channel viewing slot',
            position: 'is-top',
            type: 'is-danger',
          })
          this.loading = false
        }
      }
    },
  },
}
</script>
